export default "__VITE_ASSET__ClzTW5jH__"